import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import SEO from './SEO';
import { ZEFFY_DONATE_URL } from '../constants';

const Donate = () => {
  return (
    <BackgroundWrapper>
      <SEO
        title="Donate"
        description="Your donation provides free therapy, art supplies, essential oils, and educational resources. 100% goes to suicide prevention and mental health awareness."
        path="/donate"
      />
      <Container>
        <Title>Donate</Title>
        <Subtitle>Empowering Jojo to Prevent Suicide and Elevate Mental Health Awareness</Subtitle>

        <Description>
          Give Back JoJo is a Non Profit dedicated to mental health awareness and suicide prevention. Our goal is to have a dedicated mental health clinic that offers free art/group therapy. We want to create a warm, inviting, and safe environment by providing meals to those that attend, educational and recreational books, educational stickers for suicide prevention, and aroma therapy. We ask for your help to achieve this goal! By granting us your donation, you will help us spread positive change in mental health, suicide prevention, and bringing the community together. Thank you for being here ♥
        </Description>

        <DonateButton href={ZEFFY_DONATE_URL} target="_blank" rel="noopener noreferrer">
          Donate Now
        </DonateButton>

        <LinksStack>
          <AltPaymentLink to="/supporting-givebackjojo">
            Prefer Venmo or Zelle?
          </AltPaymentLink>
          <LearnMore to="/yourgift">Learn More</LearnMore>
        </LinksStack>
      </Container>
    </BackgroundWrapper>
  );
};

// Styled Components
const BackgroundWrapper = styled.div`
  background: #fb9e8a;
  padding: 1rem;
  min-height: 100vh;

  @media (min-width: 768px) {
    padding: 3rem 2rem;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`;

const Container = styled.div`
  text-align: center;
  padding: 1.5rem;
  background: #fcd3c1;
  border-radius: 10px;
  max-width: 1200px;
  margin: 0 auto;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

  @media (min-width: 768px) {
    padding: 3rem;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
    border-radius: 0;
    box-shadow: none;
    padding: 1.5rem;
  }
`;

const Title = styled.h2`
  font-size: 1.8rem;
  font-weight: bold;
  color: #cc4200;
  margin-bottom: 0.5rem;
  line-height: 1.2;

  @media (min-width: 768px) {
    font-size: 3rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1rem;
  color: #cc4200;
  margin: 0 auto 1.5rem;
  max-width: 800px;
  line-height: 1.4;

  @media (min-width: 768px) {
    font-size: 1.25rem;
    margin-bottom: 2rem;
  }
`;

const Description = styled.p`
  font-size: 1rem;
  color: #7a2600;
  max-width: 700px;
  margin: 0 auto 2rem;
  line-height: 1.7;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 1.05rem;
  }
`;

const DonateButton = styled.a`
  display: inline-block;
  text-decoration: none;
  background: #cc4200;
  color: white;
  font-size: 1.2rem;
  font-weight: 700;
  padding: 1rem 3rem;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  margin: 0 auto 2rem;
  transition: all 0.25s ease;
  box-shadow: 0 4px 16px rgba(204, 66, 0, 0.35);

  &:hover {
    background: #054944;
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(5, 73, 68, 0.35);
  }

  @media (min-width: 768px) {
    font-size: 1.35rem;
    padding: 1.1rem 4rem;
  }
`;

const LinksStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
`;

const LearnMore = styled(Link)`
  display: inline-block;
  font-size: 1rem;
  color: #cc4200;
  text-decoration: none;
  font-weight: 600;
  padding: 0.5rem 1.5rem;
  border-radius: 6px;
  transition: all 0.3s ease;
  text-align: center;

  &:hover {
    text-decoration: underline;
    background-color: rgba(204, 66, 0, 0.1);
  }

  @media (min-width: 768px) {
    font-size: 1.1rem;
  }
`;

const AltPaymentLink = styled(Link)`
  display: inline-block;
  font-size: 0.95rem;
  color: #054944;
  text-decoration: underline;
  font-weight: 500;
  transition: color 0.2s;

  &:hover {
    color: #cc4200;
  }
`;


export default Donate;
